import React from 'react'
import {
  components,
  ControlProps,
  OptionProps,
  Props as ISelectProps,
  GroupBase,
  InputProps,
} from 'react-select'
import SelectType from 'react-select/dist/declarations/src/Select'

import { ReactComponent as SearchIcon } from 'static/svg/search-name-icon.svg'
import { ReactComponent as ClearIndicatorIcon } from 'static/svg/clear-indicator-icon.svg'

import * as S from './styles'

declare module 'react-select/dist/declarations/src/Select' {
  export interface Props<
      Option,
      IsMulti extends boolean,
      Group extends GroupBase<Option>
  > {
      hasError?: boolean
      onClickClearIndicator?: () => void
      showClearIndicator?: boolean
  }
}

interface CustomOptionComponentProps extends OptionProps {
  searchText: string
}

const Control = ({ children, ...props }: ControlProps) => {
  return (
    <components.Control {...props}>
      <SearchIcon />
      {children}
    </components.Control>
  )
}


const Option = ({ searchText, ...props }: CustomOptionComponentProps) => {
  const { label } = props

  const searchChars = searchText.split(/\s/).filter(word => word)

  return (
    <components.Option {...props}>
      <S.CustomHighlighter
        textToHighlight={label}
        searchWords={searchChars}
      />
    </components.Option>
  )
}

const Input = ({ ...props }: InputProps) => {
  return (
    <components.Input {...props} name="search_professionals"/>
  )
}

export function Select({
  hasError,
  onClickClearIndicator,
  showClearIndicator = false,
  ...props
}: ISelectProps): JSX.Element {
  const { inputValue } = props

  const selectInputRef = React.useRef<SelectType<unknown, boolean, GroupBase<unknown>>>(null)
  
  function handleClear() {
    selectInputRef.current.focusInput()
    onClickClearIndicator()
  }

  return (
    <S.Wrapper>
      <S.Select
        ref={selectInputRef}
        classNamePrefix='reactSelect'
        menuPosition='fixed'
        hasError={hasError}
        isClearable={false}
        components={{
          Input,
          ClearIndicator: () => null,
          Control,
          Option: (props) => <Option searchText={inputValue} {...props} />,
          DropdownIndicator: () => null,
          LoadingIndicator: () => null,
        }}
        {...props}
      />

      {showClearIndicator && (
        <S.CustomClearIndicator role="button" onClick={handleClear}>
          <ClearIndicatorIcon />
        </S.CustomClearIndicator>
      )}
    </S.Wrapper>
  )
}